import omit from "just-omit"

import type { ValueOf } from "@p-ban/common/src/types"

import COGNITIVE_MEDIA from "../constant/COGNITIVE_MEDIA"
import SEMINAR_CATEGORY from "../constant/SEMINAR_CATEGORY"

export const holdIndividualConsultations = (
  seminarCategory: ValueOf<typeof SEMINAR_CATEGORY>["value"] | null,
  onlineSeminar: boolean
) => {
  return seminarCategory === SEMINAR_CATEGORY.IntroductionSeminar.value && !onlineSeminar
}

export const selectableCognitiveMedia = (seminarCategory: ValueOf<typeof SEMINAR_CATEGORY>["value"] | null) => {
  const constant =
    seminarCategory === SEMINAR_CATEGORY.QuadceptTrainingSeminar.value
      ? COGNITIVE_MEDIA
      : omit(COGNITIVE_MEDIA, COGNITIVE_MEDIA.QuadceptHomepageBanner.value, COGNITIVE_MEDIA.QuadceptEmailMagazine.value)

  return Object.entries(constant)
}
